import { useFetchRequest } from '../../../utils';
import ENDPOINTS from '../../../endpoints';

export const useFetchData = (teamId) => {
  const teamState = useFetchRequest(ENDPOINTS.getTeamDetail(teamId));

  return { teamState };
};
